module.exports = __webpack_public_path__ + "img/telegram.685f694d.png";